<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!($route.meta && $route.meta.keepAlive)" />
    <Loading></Loading>
    <Toast></Toast>
    <OpenApp />
    <SlideVerify />
    <sign-in-popup
      :text="popupInfo.text"
      :icon="popupInfo.icon"
      :close="hideSignInPopup"
      :type="popupInfo.type"
    >
    </sign-in-popup>
  </div>
</template>

<script>
import Toast from "./components/Toast"
import Loading from "./components/Loading"
import OpenApp from "./components/OpenApp"
import SlideVerify from "./components/SlideVerify"
import getParamsFromUrl from "@/utils/getParamsFromUrl"
import { mapActions, mapMutations, mapGetters } from "vuex"
import { getActivityInfo } from "@/server/interfaces"
import setDocuemntTtitle from "@/utils/setDocumentTitle"
import { initShare } from "@/utils/share"
/* 签到弹窗 */
import SignInPopup from "@/components/SignInPopup"

export default {
  name: "app",
  components: {
    Toast,
    Loading,
    OpenApp,
    SlideVerify,
    SignInPopup
  },
  computed: {
    ...mapGetters({
      activityId: "activityInfo/activityId",
      activityInfo: "activityInfo/activityInfo",
      popupInfo: "signInPopup/popupInfo"
    })
  },
  methods: {
    ...mapMutations({
      setActivityId: "activityInfo/setActivityId",
      setActivityInfo: "activityInfo/setActivityInfo",
      toast: "toast/showToast",
      showLoading: "loading/showLoading",
      hideLoading: "loading/hideLoading",
      setShareInfo: "activityInfo/setShareInfo",
      hideSignInPopup: "signInPopup/hideSignInPopup"
    }),
    ...mapActions({
      getSystemInfo: "getSystemInfo",
      getUserInfo: "userInfo/getUserInfo",
      initNfPluseShare: "activityInfo/initNfPluseShare"
      // initShareInfo: "activityInfo/initShareInfo"
    }),
    redirectRoute({ routeName }) {
      this.$router.replace({ name: routeName })
    },
    getUrlParams() {
      const params = getParamsFromUrl()
      // const hasRoute = !!params.route
      if (params.id) {
        this.setActivityId(params.id)
      }
      // if (hasRoute) {
      //   this.redirectRoute({ routeName: params.route })
      // } else {
      //   delete params.route
      //   this.$router.replace({ path: "/" })
      // }
    },
    async init() {
      window.console.log("init++++++++++++++")
      this.getUrlParams()
      await this.getSystemInfo()
      this.showLoading()
      try {
        let detailRes = await getActivityInfo({
          params: {
            id: this.activityId
          }
        })
        if (detailRes) {
          this.setActivityInfo(detailRes)
          setDocuemntTtitle(detailRes.name)
          // this.nowSelectCate = detailRes.categories[0]
          this.hideLoading()
          this.setShareInfo({
            title: this.activityInfo.share.shareTitle,
            desc: this.activityInfo.share.shareDesc,
            link: window.location.href,
            imgUrl: this.activityInfo.share.shareIcon
          })
          try {
            this.initNfPluseShare()
          } catch (e) {
            window.console.log(e)
          }
          try {
            initShare({
              shareTitle: detailRes.share.shareTitle,
              shareUrl: window.location.href,
              shareIcon: detailRes.share.shareIcon,
              shareDesc: detailRes.share.shareDesc
            })
          } catch (e) {
            window.console.log(e)
          }
          // this.initShareInfo()
        } else {
          this.toast("活动信息获取失败")
          this.hideLoading()
          this.$router.replace("/nothingnessActivity")
        }
      } catch (e) {
        this.toast("活动信息获取失败")
        this.hideLoading()
        this.$router.replace("/nothingnessActivity")
      }
      // this.initNfPluseShare()
      // await this.getUserInfo()
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  background: #f5f4f4;
  .amap-logo {
    display: none;
  }
  .amap-copyright {
    opacity: 0;
  }
}
</style>
